<section class="card-style-sec worker-exposures-sec info-popups">
  <div class="container-fluid">
    <div class="card-main-title">
      <h4 class="card-title">{{ 'Worker Exposures' | translate }} <i class="fa fa-info-circle" aria-hidden="true"
      (mouseover)="toggleInfo(true)" (mouseout)="toggleInfo(false)"></i><span
    class="font-light d-block">{{ '(Count)' | translate }}</span></h4>
    @if (showInfo) {
      <div class="info-box">
        <h4><strong>{{ 'Worker Exposures' | translate }}</strong></h4>
        <span class="text-small">{{ 'This is where you can see and manage your Devices.' | translate }}</span>
        <span class="text-small">{{ 'A device is an APT sensor device that is registered to your organisation. A device needs to be assigned to an End Point in order to initiate recording of data.' | translate }}</span>
      </div>
    }
  </div>
  <div class="row">
    @for (exp of workerExposures; track trackByIndex($index)) {
      <div class="col-sm-12 col-md-6 col-lg-3">
        <div class="card-box green-card-box">
          <div class="icon-div">
            <svg width="27" height="29" viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M26.6611 20.1638C26.6611 17.4884 24.4724 15.2998 21.797 15.2998H17.6707C17.2998 15.2998 16.9401 15.3454 16.5928 15.4256C16.9662 16.3055 17.1728 17.2727 17.1728 18.2868V24.4746H26.6611V20.1638Z"
                [style.fill]="'#'+exp.color" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M19.7337 12.4426C22.0447 12.4426 23.9355 10.5518 23.9355 8.24068V7.29953C23.9355 4.98839 22.0447 3.09766 19.7337 3.09766C17.4225 3.09766 15.5317 4.98839 15.5317 7.29953V8.24068C15.5317 10.5518 17.4225 12.4426 19.7337 12.4426Z"
                  [style.fill]="'#'+exp.color" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M15.1404 18.2878C15.1404 15.3646 12.7484 12.9727 9.82525 12.9727H5.31639C2.39194 12.9727 0 15.3646 0 18.2878V24.4755H15.1404V18.2878Z"
                    [style.fill]="'#'+exp.color" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M7.56942 10.4092C10.1432 10.4092 12.2498 8.30342 12.2498 5.72897V4.68028C12.2498 2.10583 10.1432 0 7.56942 0C4.99564 0 2.88916 2.10583 2.88916 4.68028V5.72897C2.88916 8.30342 4.99564 10.4092 7.56942 10.4092Z"
                      [style.fill]="'#'+exp.color" />
                      <path d="M8 20V29" stroke="white" stroke-width="3" />
                    </svg>
                  </div>
                  <h6 class="icon-ttl">{{ exp.name | translate }}</h6>
                  <h2 class="count-txt">{{exp.workers}} <span [style.color]="'#'+exp.color+' !important'"
                    class="font-300">(@if (exp?.change > 0) {
                    <span [style.color]="'#'+exp.color">+</span>
                  }{{exp?.change.toFixed(2)}}%)</span></h2>
                  <div class="progress-bar-div">
                    <div class="progress lighten-4 tooltipped" data-position="top"
                      data-tooltip="Progress was at 50% when tested">
                      <div class="determinate" [style.background-color]="'#'+exp.color"
                      [style.width.%]="(exp.percentageOfWorkers * 100)" style="animation: grow 2s;"></div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          @if (thresholdLegend.length) {
            <ul class="count-info-list d-flex">
              @for (threshold of thresholdLegend; track trackByIndex($index)) {
                <li><span class="square-point"
                [style.background-color]="threshold.colorHex"></span><span
              class="text">{{threshold.label}}</span></li>
            }
          </ul>
        }
      </div>
    </section>
